// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"list-1oiGSjUb clearfix"};